{
  "pt": {
    "project": {
      "actions": {
        "activate": "Ativar",
        "addProjectMaintainer": "Adicionar o responsável pelo projeto",
        "add_as_partner": "Adicionar como parceiro",
        "add_as_partner_description": "Tem a certeza de que pretende adicionar {partner} como parceiro deste projeto?",
        "add_project_partner": "Adicionar parceiro de projeto",
        "additional_information": "Informações adicionais",
        "changeProjectLogin": "Alterar a imagem do projeto",
        "changeProjectLogo": "Alterar o logótipo do projeto",
        "deactivate": "Desativar",
        "edit": "Editar",
        "finishRequest": "Enviar pedido",
        "follow": "Seguir",
        "giveAccess": "Dar acesso",
        "maintainerAdd": "Adicionar o responsável pelo projeto",
        "maintainerAddDescription": "Tem a certeza de que pretende conceder a {maintainer} acesso a este projeto?",
        "maintainerRemove": "Remover o responsável pelo projeto",
        "maintainerRemoveDescription": "Tem a certeza de que pretende revogar o acesso a este projeto para {maintainer}?",
        "new": "Novo projeto",
        "next": "Seguinte",
        "remove_partner": "Remover {partner}",
        "remove_project_partner": "Remover parceiro de projeto",
        "remove_project_partner_description": "Tem a certeza de que pretende remover {partner} dos parceiros de projeto?",
        "selectOption": "Selecionar opção",
        "selectTemplate": "Selecionar modelo",
        "submit": "Criar projeto",
        "unFollow": "Deixar de seguir"
      },
      "attributes": {
        "address": "Endereço",
        "currency": "Moeda",
        "delivery_date_actual": "Data de fim prevista",
        "delivery_date_contractual": "Data de fim do contrato",
        "description": "Descrição",
        "internal_note": "Nota interna do projeto",
        "measurement": "Unidade de medida",
        "name": "Nome",
        "picture_login_url": "Imagem do projeto",
        "picture_logo_url": "Logótipo do projeto",
        "quotity_total": "Montante total da transferência",
        "skip_building": "Ocultar edifício",
        "skip_lot": "Esconder o enredo",
        "skip_phase": "Ocultar fase",
        "skip_unit": "Unidade de habitação (projeto de unidade única)",
        "start_date": "Data de início",
        "units_count": "Número de unidades criadas",
        "units_count_max": "Número máximo de unidades",
        "vat_percentage": "IVA %",
        "website_url": "URL do sítio Web"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Capacidade atingida, entre em contato conosco."
        }
      },
      "import": {
        "add": "+ Adicionar",
        "add_instead": "Na verdade, quero acrescentar {levels}",
        "building": "edifício",
        "buildings": "edifícios",
        "changed_mind": "Mudei de ideias",
        "create_new": "Qual é o nome do {type}",
        "download_template": "Descarregar o modelo de importação",
        "drop_or_upload": "Largue o modelo aqui ou clique para carregar",
        "error_line": "Erro na linha",
        "fill_space_info": "Preencher o modelo com informações sobre o espaço",
        "fill_unit_info": "Preencher o modelo com as informações da unidade",
        "fix_file_upload": "Por favor, corrija os problemas e carregue o ficheiro novamente.</br>As unidades existentes não serão removidas, mas serão actualizadas se houver alguma alteração no ficheiro para essa unidade desde o último carregamento.",
        "fix_file_upload_space": "Por favor, corrija os problemas e carregue o ficheiro novamente.</br>Os espaços existentes não serão removidos, mas serão actualizados se houver alguma alteração no ficheiro para esse espaço desde o último carregamento.",
        "for": "para",
        "import_column_title": "Deseja adicionar {column_type}?",
        "import_partial_success": "A importação foi parcialmente bem sucedida. Abaixo estão os erros restantes:",
        "import_spaces": "Importar espaços",
        "import_units": "Unidades de importação para",
        "lot": "lote",
        "lots": "lotes",
        "no": "não",
        "noLevels": "Não {levels}",
        "phase": "fase",
        "phases": "fases",
        "plot": "lote",
        "select_level_above": "Seleccione um {level} para continuar",
        "start_upload": "Iniciar carregamento",
        "step": "Etapa",
        "unit_info": "Poderá importar unidades depois de o projeto ter sido criado",
        "unit_limit": "Pretende importar mais unidades do que as que lhe são permitidas. Retire {exceeded_by} unidade(s) ou peça-nos para aumentar o número de unidades permitidas",
        "units": "unidades",
        "upload_filled_template": "Carregar modelo preenchido",
        "upload_new_file": "Carregar novo ficheiro",
        "upload_spaces": "Carregar espaços",
        "upload_units": "Carregar unidades",
        "uploaded_file": "Ficheiro carregado",
        "validations_failed": "Algumas validações falharam",
        "yes": "sim"
      },
      "labels": {
        "activate": "Projeto Activeer",
        "checkLevels": "Verifique os níveis que pretende adicionar:",
        "companyInfo": "Informações sobre a empresa",
        "companyNameTitle": "Nome da empresa",
        "congratulationsNewProject": "Parabéns pelo seu novo projeto",
        "copyFromTemplate": "Copiar o projeto modelo (opcional)",
        "customer_can_create_issue": "O cliente pode criar um obstáculo",
        "customersCanLogIn": "Os clientes deste projeto podem iniciar sessão com",
        "deactivate": "Projeto Deactiveer",
        "deactivated": "Desativado",
        "deactivatedProjects": "Projectos Desativados",
        "download_export": "Descarregar a minha exportação",
        "downloading_export": "Descarregamento",
        "endsOn": "Termina no {enddate}",
        "export_expiration": "Os seus dados de exportação estão prontos para serem descarregados. Ficarão disponíveis até {time}",
        "export_explanation": "Solicite uma exportação de todos os seus dados, incluindo conversas e documentos.",
        "export_failed": "A exportação falhou",
        "export_file": "Exportar o meu ficheiro",
        "export_notification_snack": "A recolha do seu ficheiro pode demorar alguns minutos. Receberá uma notificação quando o ficheiro estiver pronto para ser descarregado.",
        "export_prepared": "Os seus dados de exportação estarão prontos para serem descarregados em breve.",
        "export_preparing": "Preparar a exportação",
        "filterProject": "Selecionar um projeto",
        "finalSteps": "Etapas finais",
        "follow": "Siga {project} para receber notificações.",
        "followedProjects": "Os meus projectos",
        "following": "A seguir",
        "general": "Geral",
        "importContacts": "Sim, gostaria de importar contactos de clientes",
        "importInformationSubtitle": "Em vez de adicionar espaços e contactos um a um, podemos ajudá-lo com a importação de um ficheiro CSV. Marque as caixas abaixo e um membro da equipa Ziggu entrará em contacto consigo.",
        "importInformationTitle": "Importar informações?",
        "importSpaces": "Sim, gostaria de importar lugares de estacionamento e de armazenamento",
        "importUnits": "Sim, gostaria de importar unidades e respectivas informações",
        "included": "Incluído",
        "internal": "Interno",
        "invoice_subtitle": "Só enviaremos uma fatura se for necessário, por exemplo, quando já não houver unidades no seu pacote.",
        "invoice_title": "Para que endereço eletrónico podemos enviar as nossas facturas?",
        "isTemplateProject": "Este é um projeto modelo",
        "levelBuildingExplainer": "Seleccione esta opção se tiver várias unidades dentro de um ou mais edifícios.",
        "levelPhaseExplainer": "Seleccione esta opção se o seu projeto for construído em diferentes fases, distribuídas ao longo do tempo.",
        "levelPlotExplainer": "Seleccione esta opção se o seu projeto consistir em várias parcelas de terreno.",
        "levelProjectExplainer": "O seu projeto é o maior bloco de construção e é essencial para começar.",
        "levelUnitExplainer": "A unidade é o bloco de construção mais pequeno. É a casa ou o apartamento que está a construir para os seus clientes.",
        "levels": "Estrutura do projeto",
        "limitReached": "Limite do projeto atingido",
        "multiUnits": "Unidades múltiplas",
        "nameTitle": "O nome do projeto?",
        "newProjectTitle": "Vamos criar o seu novo projeto!",
        "noAccess": "Não tem acesso a este projeto",
        "noFollowedProjects": "Clique no ícone de notificação para seguir um projeto.",
        "noProjects": "Não foram encontrados projectos",
        "optional_information": "Informações facultativas",
        "optional_information_subtitle": "Há mais alguma coisa que gostaria de partilhar connosco?",
        "otherProjects": "Outros projectos",
        "outOfProjects": "Parece que o seu pacote ficou sem projectos activos.",
        "outOfProjectsContact": "Contacte o Ziggu para aumentar o seu pacote e continuar a criar projectos.",
        "partner_invitation_notice": "{partner} ainda não foi convidado. Será enviado um convite quando {partner} for adicionado aos parceiros do projeto.",
        "pendingProjects": "{first_project_name} foi solicitado e está atualmente a ser implementado pela Ziggu | {count} projectos foram solicitados e estão atualmente a ser implementados pela Ziggu",
        "permission_partner_project": "Um parceiro com quem partilhar facilmente documentos e propostas",
        "permissionsOwnerOnly": "Apenas os membros da equipa com a função Proprietário podem adicionar novos responsáveis pelo projeto",
        "permissionsRoleMaintainer": "Um membro da equipa com acesso a este projeto",
        "project": "Projeto {project}",
        "projectBranding": "Marca do projeto",
        "projectIsDeactivated": "Este projeto está desativado",
        "projectMaintainers": "Mantenedores de projectos",
        "projectName": "Nome do projeto",
        "projectStructure": "Estrutura do projeto",
        "projectStructureSubtitle": "Agora tem a possibilidade de adicionar 3 níveis extra para organizar melhor as suas unidades.</br>Vamos analisar cada um deles, passo a passo.",
        "projectStructureSubtitleOld": "A estrutura do projeto é definida uma vez no início do projeto",
        "project_label": "Projeto",
        "project_partners": "Parceiros do projeto",
        "projects": "Projectos",
        "remove_project_partner_prohibited": "{partner} é adicionado às decisões deste projeto e não pode ser removido dos parceiros de projeto.",
        "remove_project_partner_prohibited_label": "O parceiro de projeto não pode ser removido",
        "searchProject": "Pesquisar projeto",
        "searchProjects": "Pesquisar projeto",
        "selectATemplateProject": "Selecionar um projeto modelo",
        "selected": "Selecionado",
        "showProject": "Mostrar projeto",
        "singleUnit": "Unidade única",
        "spaces": "Espaços",
        "startsOn": "Começa no {startdate}",
        "step1Info": "Vamos rever alguns pormenores para começar.",
        "step1Title": "Parabéns pelo seu novo projeto!",
        "step2Info": "A que empresa podemos endereçar a fatura?",
        "step2Title": "Detalhes da faturação",
        "step3Title": "Precisa de níveis intermédios?",
        "step4Info": "O que acontece a seguir? Ziggu irá configurar {project} dentro de 3 a 5 dias úteis. Será notificado quando tudo estiver pronto.",
        "templateProjects": "Projectos de modelos",
        "unFollow": "Deixou de receber notificações para {project}.",
        "underConstruction": "Em construção",
        "units": "Unidades",
        "unitsActiveRemaining": "UNIDADES DISPONÍVEIS",
        "unitsAllotted": "UNIDADES ATRIBUÍDAS",
        "unitsCountSubtitle": "Quantas unidades?",
        "unselected": "Clique para selecionar",
        "youAreEditingTemplateProject": "Está a editar um projeto modelo",
        "you_have_inbound_emails": "Tem 1 e-mail de entrada não processado | Tem {number} e-mails de entrada não processados"
      },
      "messages": {
        "units_count_max": "Se pretender criar mais unidades, contacte-nos através do botão de conversação."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Vamos criar o seu novo projeto!"
          },
          "step_2": {
            "title": "Este projeto contém 1 ou mais unidades"
          },
          "step_3": {
            "subtitle": "Clique nas cartas para ativar os níveis intermédios.",
            "title": "Precisa de níveis intermédios?"
          },
          "step_4": {
            "info": "Os modelos de decisão e de inquérito podem ser importados assim que as unidades forem criadas para este projeto.",
            "placeholder": "Selecione um projeto ou deixe-o vazio se não pretender copiar a partir de um modelo",
            "title": "Utilizar um modelo de projeto como base?"
          }
        }
      },
      "navigation": {
        "backToProjects": "Voltar aos projectos"
      },
      "notifications": {
        "emailHasBeenCopied": "Endereço de e-mail copiado com sucesso",
        "pictureChangedSuccessfully": "A imagem foi actualizada. As alterações podem demorar até uma hora a serem visíveis.",
        "tokenCopied": "Token copiado com sucesso",
        "urlHasBeenCopied": "Url copiado com sucesso"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Não tem acesso a nenhum projeto. Peça a um membro da equipa com a função de Proprietário para lhe conceder acesso.",
            "title": "Nenhum projeto"
          }
        },
        "partners": {
          "noProjectSubtitle": "Será notificado quando lhe for atribuído um novo projeto",
          "noProjectTitle": "Nenhum projeto ainda"
        }
      },
      "snackbars": {
        "duplicate": "O processo de cópia foi iniciado e pode demorar alguns minutos. Por favor, actualize a página após alguns minutos."
      },
      "sort": {
        "nameAsc": "Nome A → Z",
        "nameDesc": "Nome Z → A",
        "newest": "Mais recente primeiro",
        "oldest": "Mais antigo primeiro"
      },
      "toasts": {
        "activateSuccess": "{project_name} foi ativado com sucesso.",
        "deactivateSuccess": "{project_name} foi desativado com sucesso.",
        "duplicate": "O projeto está pronto, mas a entrega do pão pode demorar alguns minutos."
      },
      "tooltip": {
        "hasNoActiveUnits": "Não tem unidades activas",
        "turnOffNotifications": "Desativar as notificações para {project}",
        "turnOnNotifications": "Ativar as notificações para {project}"
      },
      "validation": {
        "addressInformationRequired": "Informações de endereço necessárias",
        "companyNeedName": "Nome da empresa necessário",
        "companyNeedVatNumber": "Número de IVA necessário",
        "dateAfter": "A data deve ser posterior à data de início",
        "lessThanOrEqual": "O número tem de ser menor ou igual a {max_number}",
        "maxLength": "O nome pode ter no máximo {length} caracteres",
        "nameAlreadyTaken": "O nome já foi escolhido para este projeto",
        "needName": "Título necessário",
        "needNumber": "Deve ser um número (por exemplo, 850)",
        "needUnitsCount": "A contagem de unidades é necessária"
      }
    }
  }
}
